import BaseView from './utilities/baseView.js';
import { tns } from "tiny-slider";
import JustValidate from 'just-validate';

class DefaultView extends BaseView {


    constructor() {
        var cfg = {
            settings: {},
            locale: {
            }
        };

        super(cfg, true);
    }

}

new DefaultView();